import { Component, Input } from '@angular/core';

import { SedsButtonAbstractComponent } from './seds-button-abstract';
import { SedsPositionsOptions } from '../../shared/enums/seds-positions-options.enum';
import { SedsPositionsOptionsType } from '../../shared/types/seds-positions-options.type';
import { SedsSizeOptions } from '../../shared/enums/seds-size-options.enum';
import { SedsSizeOptionsType } from '../../shared/types/seds-size-options.type';

@Component({
    template: '',
    standalone: false
})
export abstract class SedsSquareButtonAbstractComponent extends SedsButtonAbstractComponent {
  @Input()
  iconPosition: SedsPositionsOptions | SedsPositionsOptionsType = SedsPositionsOptions.LEFT;

  @Input()
  loading = false;

  @Input()
  size: SedsSizeOptionsType | SedsSizeOptions = SedsSizeOptions.STANDARD;

  @Input()
  title = '';

  @Input()
  width = '';
}
